import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import FormLabel from '../FormLabel';
import FormError from '../FormError';
import { StyledContainer, StyledWrapper, StyledInputWrapper, StyledInput } from './styled';

const Input = forwardRef(({ id, placeholder, label, type, name, value, defaultValue, error, fullWidth, maxWidth, autoComplete, maxLength, disabled, errorText, startAdornment, endAdornment, color, readonly, customStyle, list, noBorder, min, max, onChange, onKeyPress, onClick, onBlur }, ref) => {
  return (
    <StyledContainer
      disabled={disabled}
      readonly={readonly}
      error={error}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      onClick={onClick}
      customStyle={customStyle}
      noBorder={noBorder}
    >
      {label && <FormLabel htmlFor={id}>{label}</FormLabel>}
      <StyledWrapper>
        {startAdornment && startAdornment}
        <StyledInputWrapper>
          <StyledInput
            ref={ref}
            id={id}
            placeholder={placeholder}
            type={type}
            name={name}
            onChange={onChange}
            onKeyPress={onKeyPress}
            value={value}
            autoComplete={autoComplete}
            maxLength={maxLength}
            color={color}
            paddingRight={!!startAdornment}
            paddingLeft={!!endAdornment}
            readOnly={readonly}
            list={list}
            defaultValue={defaultValue}
            onBlur={onBlur}
            min={min}
            max={max}
          />
        </StyledInputWrapper>
        {endAdornment && endAdornment}
      </StyledWrapper>
      {error && errorText && <FormError>{errorText}</FormError>}
    </StyledContainer>
  )
});

Input.propTypes = {
  id: PropTypes.string,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  type: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.any,
  defaultValue: PropTypes.any,
  error: PropTypes.bool,
  fullWidth: PropTypes.bool,
  maxWidth: PropTypes.string,
  autoComplete: PropTypes.string,
  maxLength: PropTypes.number,
  disabled: PropTypes.bool,
  errorText: PropTypes.string,
  startAdornment: PropTypes.node,
  endAdornment: PropTypes.node,
  color: PropTypes.string,
  readonly: PropTypes.bool,
  customStyle: PropTypes.array,
  list: PropTypes.string,
  noBorder: PropTypes.bool,
  min: PropTypes.any,
  max: PropTypes.any,
  onKeyPress: PropTypes.func,
  onChange: PropTypes.func,
  onBlur: PropTypes.func
};

Input.defaultProps = {
  type: 'text',
  error: false,
  fullWidth: true,
  maxWidth: 'none',
  autoComplete: 'on',
  disabled: false,
  readonly: false,
  noBorder: false,
  onChange: undefined
};

export default React.memo(Input);